import { Injectable, ElementRef } from '@angular/core';
import { PromptService } from './prompt.service';
import { AppSettingService } from './app-setting.service';
import { TableExportConfig } from '../com-library/table-export-templete/table-export-templete.component';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver'
import { NzModalService } from 'ng-zorro-antd';
import { ExportTypeComponent } from '../com-library/export-type/export-type.component';

@Injectable()
export class TableExportService {

  constructor(private promptService: PromptService,
    private appSettingService: AppSettingService,
    private httpClient: HttpClient,
    private modalService: NzModalService) { }

  public doExport(type: 'excel' | 'pdf' | 'word' | 'print' | 'noprint', tableExportConfig: TableExportConfig) {
    switch (type) {
      case 'noprint':
        this.modalService.create({
          nzTitle: '导出',
          nzContent: ExportTypeComponent,
          nzComponentParams: {
            title: tableExportConfig.title,
            onExport: (nextType: 'excel' | 'pdf' | 'word') => {
              this.doExport(nextType, tableExportConfig);
            }
          }
        })
        break;
      case 'excel':
        this.exportToExcel(tableExportConfig);
        break;
      case 'pdf':
        this.exportToPdf(tableExportConfig);
        break;
      case 'word':
        this.exportToWord(tableExportConfig);
        break;
      case 'print':
        this.doPrint(tableExportConfig);
        break;
    }
  }

  //打印
  private doPrint(tableExportConfig: TableExportConfig) {
    this.promptService.showloading("正在准备打印").subscribe();
    var iframes = document.body.getElementsByTagName("iframe");
    if (iframes != null && iframes.length > 0) {
      for (var i = 0; i < iframes.length; i++) {
        document.body.removeChild(iframes[i]);
      }
    }
    var printUrl = window.top.location.origin + "/" + this.appSettingService.getPrintUrl() + "/print";
    var iframe = document.createElement("iframe") as HTMLIFrameElement;
    iframe.frameBorder = "0";
    iframe.src = printUrl;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    tableExportConfig.print = true;
    tableExportConfig.onPrepared = () => {
      this.promptService.closeloading();
    }
    iframe.contentWindow["tableExportConfig"] = tableExportConfig;
  }

  //导出word
  private exportToWord(tableExportConfig: TableExportConfig) {
    this.promptService.showloading("正在准备导出").subscribe();
    this.httpClient
      .post(this.appSettingService.getExportUrl('toword'), tableExportConfig, {
        responseType: 'blob'
      })
      .subscribe(blob => {
        saveAs(blob, tableExportConfig.title);
        this.promptService.closeloading();
      }, err => {
        this.promptService.closeloading();
      })
  }

  private exportToExcel(tableExportConfig: TableExportConfig) {
    this.promptService.showloading("正在准备导出").subscribe();
    this.httpClient
      .post(this.appSettingService.getExportUrl('toexcel'), tableExportConfig, {
        responseType: 'blob'
      })
      .subscribe(blob => {
        saveAs(blob, tableExportConfig.title + ".xls");
        this.promptService.closeloading();
      }, err => {
        this.promptService.closeloading();
      })
  }

  private exportToPdf(tableExportConfig: TableExportConfig) {
    this.promptService.showloading("正在准备导出").subscribe();
    this.httpClient
      .post(this.appSettingService.getExportUrl('topdf'), tableExportConfig, {
        responseType: 'blob'
      })
      .subscribe(blob => {
        saveAs(blob, tableExportConfig.title);
        this.promptService.closeloading();
      }, err => {
        this.promptService.closeloading();
      })
  }
}
